/**
 * AI Hub Service
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.3.2
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

export interface ManagementAiPresetRequest { 
    type: ManagementAiPresetRequest.TypeEnum;
    prompt: string;
    model: string;
    provider: ManagementAiPresetRequest.ProviderEnum;
}
export namespace ManagementAiPresetRequest {
    export type TypeEnum = 'CLIENT_REPORT_SUMMARY' | 'CLIP_REPORT_SUMMARY' | 'CLIP_TRANSCRIPTION' | 'CLIP_SIMILAR' | 'CLIP_AUTO_TAG' | 'CLIP_SENTIMENT' | 'CLIP_TRANSLATION' | 'TRANSCRIPTION_TRANSCRIPTION' | 'TRANSCRIPTION_PROOFREAD' | 'CONTRACT_NOTICE_AUTO_TAG' | 'CONTRACT_NOTICE_AUTO_TAG_V2' | 'CONTRACT_NOTICE_TRANSLATION' | 'ANALYTICS_SUMMARY';
    export const TypeEnum = {
        CLIENTREPORTSUMMARY: 'CLIENT_REPORT_SUMMARY' as TypeEnum,
        CLIPREPORTSUMMARY: 'CLIP_REPORT_SUMMARY' as TypeEnum,
        CLIPTRANSCRIPTION: 'CLIP_TRANSCRIPTION' as TypeEnum,
        CLIPSIMILAR: 'CLIP_SIMILAR' as TypeEnum,
        CLIPAUTOTAG: 'CLIP_AUTO_TAG' as TypeEnum,
        CLIPSENTIMENT: 'CLIP_SENTIMENT' as TypeEnum,
        CLIPTRANSLATION: 'CLIP_TRANSLATION' as TypeEnum,
        TRANSCRIPTIONTRANSCRIPTION: 'TRANSCRIPTION_TRANSCRIPTION' as TypeEnum,
        TRANSCRIPTIONPROOFREAD: 'TRANSCRIPTION_PROOFREAD' as TypeEnum,
        CONTRACTNOTICEAUTOTAG: 'CONTRACT_NOTICE_AUTO_TAG' as TypeEnum,
        CONTRACTNOTICEAUTOTAGV2: 'CONTRACT_NOTICE_AUTO_TAG_V2' as TypeEnum,
        CONTRACTNOTICETRANSLATION: 'CONTRACT_NOTICE_TRANSLATION' as TypeEnum,
        ANALYTICSSUMMARY: 'ANALYTICS_SUMMARY' as TypeEnum
    };
    export type ProviderEnum = 'OPENAI' | 'GEMINI' | 'OPEN_ROUTER';
    export const ProviderEnum = {
        OPENAI: 'OPENAI' as ProviderEnum,
        GEMINI: 'GEMINI' as ProviderEnum,
        OPENROUTER: 'OPEN_ROUTER' as ProviderEnum
    };
}